import React, { Component } from 'react';
import { Redirect, Route, NavLink, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';


class Register extends Component {
    constructor(props) {
        super(props);

        this.onClickRegister = this.onClickRegister.bind(this);
        this.updateANumber = this.updateANumber.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.updateCPassword = this.updateCPassword.bind(this);
        this.updateCredentials= this.updateCredentials.bind(this);



         this.state={
            collapse: false,
            showError: false,
            loading: false,
            logged_in:true,
            access_token:"",
            user_details:{},
            authentication_error: false,
            valid_anumber:false,
            valid_password: false,
            valid_cpassword: false,
            validation_message:"",
            error_message:"Login failed. Please enter valid credentials.",
            anumber_error_message:"Admission number required",
            password_error_message: "Password required",
            cpassword_error_message: "Password confirmation required",
            display_anumber_error:false,
            display_password_error:false,
            display_cpassword_error:false,
            anumber: "",
            password: "",
            cpassword: ""

         }
      }


      updateCredentials(accessToken, userDetails)
    {
        console.log("init credentials update");
        this.props.updateAdminCredentials(accessToken, userDetails);
    }


    onClickRegister() {
        if(this.state.valid_anumber && this.state.valid_password)
        {
                this.setState({loading:true});
                const _this = this;
                const url = this.props.base_url +"/student/register"

                const url_to_send = _this.props.portal_base_url +"/student/verifyaccount"

                console.log("Ver url ", url_to_send);

                superagent
                .post(url)
                .send({admission_number:_this.state.anumber, base_url: url_to_send,  password:_this.state.password})
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    const error = res.body.error;
                    console.log("Response", res.body);


                    if(error)
                    {
                        const message = res.body.message;
                        _this.setState({loading:false, authentication_error:true, error_message:message});
                    }
                    else
                    {
                        const message = res.body.message;
                        _this.setState({loading:false, authentication_error:true, error_message:message});
                    }

                })
                .catch(function(err){

                    const error_response_message = err +".\n\n Please contact system admin to allow your IP access.";
                    _this.setState({loading:false, authentication_error:true, error_message:error_response_message});
                });


        }

        else
        {
            this.setState({display_anumber_error:true, display_password_error:true, display_cpassword_error:true});

        }
      }



      updateANumber(event) {
        event.preventDefault();

        const anumber_value = event.target.value;


        if(0 === anumber_value.length)
        {
            this.setState({anumber:anumber_value, valid_anumber:false, anumber_error_message:"Please enter admission number", display_anumber_error:true})
        }
        else
        {
            this.setState({anumber:anumber_value, valid_anumber:true, anumber_error_message:"", display_anumber_error:false})
        }
      }


      updatePassword(event) {
        event.preventDefault();

        const password_value = event.target.value;

        this.setState({password:event.target.value});

        if(0 === password_value.length)
        {
            this.setState({password:password_value, valid_password:false, password_error_message:"Please enter password", display_password_error:true})
        }
        else
        {
          if(!this.state.valid_cpassword && this.state.cpassword.length > 0)
          {
            if(this.state.cpassword != password_value)
            {
                this.setState({valid_cpassword:false, cpassword_error_message:"Password not yet matching", display_cpassword_error:true})
            }
            else
            {
                this.setState({valid_cpassword:true, cpassword_error_message:"", display_cpassword_error:false})
            }
          }
          else {
            this.setState({valid_cpassword:true, cpassword_error_message:"", display_cpassword_error:false});
          }

            this.setState({password:password_value, valid_password:true, password_error_message:"", display_password_error:false})
        }
      }

      updateCPassword(event) {
        event.preventDefault();

        let password_value = event.target.value;

        this.setState({cpassword:event.target.value});

        if(0 === password_value.length)
        {
            this.setState({cpassword:password_value, valid_cpassword:false, cpassword_error_message:"Please confirm  your password", display_cpassword_error:true})
        }
        if(this.state.password != password_value)
        {
            this.setState({cpassword:password_value, valid_cpassword:false, cpassword_error_message:"Password not yet matching", display_cpassword_error:true})
        }
        else
        {
            this.setState({cpassword:password_value, valid_cpassword:true, cpassword_error_message:"", display_cpassword_error:false})
        }
      }


      renderLoadingProgress()
      {
          if(this.state.loading)
          {
              return(
                <div className="loading-progress">
                <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
                </div>
            </div>

              );
          }
          else{
              return null;
          }
      }

      renderAnumberError()
      {
          if(this.state.display_anumber_error && !this.state.valid_anumber)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.anumber_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }

      renderCpasswordError()
      {
          if(this.state.display_cpassword_error && !this.state.valid_cpassword)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.cpassword_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }

      renderPasswordError()
      {
          if(this.state.display_password_error && !this.state.valid_password)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.password_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }

      renderErrorMessage()
      {
          if(this.state.authentication_error && !this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p color="red">{this.state.error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }

      }




  render() {

    const _this = this;

    return (

        <form className="form login-form" method="" action="">

                  <div className="card card-login">


                    <div margin-top="-60px" className="card-header-login card-header card-header-rose text-center ">
                        <div style={{top:0}} className="cont-center">
                            <Link  to="/"><img src="/img/logotuc.png" alt="logo" height="120"/></Link>
                        </div>

                        <h4 className="card-title">Create Student Account</h4>
                        {this.renderLoadingProgress()}
                        {this.renderErrorMessage()}
                    </div>
                    <div className="card-body ">


                      <span className="bmd-form-group">
                        <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                              
                            </span>
                          </div>
                         
                          <input type="text"  onChange={_this.updateANumber.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Admission Number"/>
                        </div>
                        {this.renderAnumberError()}
                      </span>



                      <span className="bmd-form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="material-icons">lock_outline</i>
                            </span>
                          </div>
                          <input type="password" onChange={_this.updatePassword.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Password..."/>
                        </div>
                        {this.renderPasswordError()}
                      </span>

                      <span className="bmd-form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="material-icons">lock_outline</i>
                            </span>
                          </div>
                          <input type="password" onChange={_this.updateCPassword.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Confirm Password..."/>
                        </div>
                        {this.renderCpasswordError()}
                      </span>


                    </div>
                    <div className="card-footer justify-content-center">
                      <button type="submit" onClick={_this.onClickRegister.bind(_this)} onTap={_this.onClickRegister.bind(_this)} disabled={this.state.loading}  className="btn btn-green">Register<div className="ripple-container"></div></button>
                    </div>



                    <div margin-bottom="10px" className="card-footer justify-content-center">

                      Already Registered ?  <Link to="/student/login" >Login </Link>
                    </div>

                    <div className="card-footer justify-content-center">

                      Already Registered, but forgotten password?<Link to="/student/forgotpassword" >Reet</Link>
                    </div>

                  </div>
        </form>



    );
  }
}

export default Register;
